/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-container fluid pa-0>
    <v-layout wrap>
      <v-flex>
        <header-test :theme="isDark"></header-test>
        <data-view v-if="isComponent('pr-dash')"></data-view>
        <no-device v-else :message="subscriptionMessage"></no-device>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapGettersMixin } from '@/util/mixin/index'

export default {
  mixins: [ mapGettersMixin ],
  data () {
    return {
      subscriptionMessage: 'This feature is not applicable for your plant.'
    }
  },
  components: {
    'header-test': () => import('@/components/dashboard-inverter/Header'),
    'data-view': () => import('@/components/pr/DataView'),
    'no-device': () => import('@/components/utility/NoDevice.vue')
  },
  computed: {
    ...mapGetters([
      'isComponent'
    ])
  }
}
</script>
